/*
 * Daring Martin — Barra fija "Agregar al carrito" (mobile).
 *
 * Principio de diseño: este archivo NO implementa un mecanismo de
 * compra propio. Es un proxy visual sobre el <product-form> real de
 * la PDP (snippets/buy-buttons.liquid + assets/product-form.js):
 *   - el precio se copia (clona) del contenedor de precio real cada
 *     vez que cambia (mismo nodo que actualiza product-info.js al
 *     cambiar de variante), nunca se recalcula por separado.
 *   - el botón de la barra jamás envía el form por su cuenta: su único
 *     efecto es togglear una copia visual del estado del botón real y,
 *     al hacer click, disparar realButton.click() — el mismo submit,
 *     con la misma variante, mismo manejo de agotado y mismo
 *     comportamiento post-compra (incluida la navegación a /cart,
 *     porque el header custom de esta tienda no trae
 *     <cart-notification>/<cart-drawer> — ver ROADMAP_SITIO.md).
 */
(function () {
  function initDmStickyAtc(root) {
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;

    var realButton = document.getElementById('ProductSubmitButton-' + sectionId);
    // Sin botón real no hay nada que proxear: no se muestra ninguna
    // barra (evita cualquier posibilidad de mecanismo huérfano).
    if (!realButton) return;

    var realPriceContainer = document.getElementById('price-' + sectionId);
    var priceEl = root.querySelector('[data-dm-sticky-price]');
    var button = root.querySelector('[data-dm-sticky-button]');
    var buttonText = root.querySelector('[data-dm-sticky-button-text]');

    function syncPrice() {
      if (!priceEl || !realPriceContainer) return;
      var realPrice = realPriceContainer.querySelector('.price');
      if (realPrice) {
        priceEl.innerHTML = realPrice.outerHTML;
      }
    }

    function syncButton() {
      var isDisabled = realButton.disabled || realButton.hasAttribute('disabled');
      var ariaDisabled = realButton.getAttribute('aria-disabled') === 'true';
      if (button) {
        button.disabled = isDisabled;
        button.setAttribute('aria-disabled', isDisabled || ariaDisabled ? 'true' : 'false');
        button.classList.toggle('is-loading', realButton.classList.contains('loading'));
      }

      var realSpan = realButton.querySelector('span');
      if (buttonText && realSpan) {
        var label = realSpan.textContent.trim();
        buttonText.textContent = label;
        // DM fix (verificador 2026-08-21): el aria-label quedaba fijo en
        // "Agregar al carrito" aunque el texto visible cambiara a
        // "Agotado" — un lector de pantalla anunciaba una etiqueta
        // desactualizada. Se sincroniza siempre contra el texto real
        // del botón real, en vez de mantener un aria-label estático.
        if (button) button.setAttribute('aria-label', label);
      }
    }

    syncPrice();
    syncButton();

    if (realPriceContainer) {
      new MutationObserver(syncPrice).observe(realPriceContainer, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    new MutationObserver(syncButton).observe(realButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    if (button) {
      button.addEventListener('click', function () {
        // Guardia local, defensiva: el guard real vive en
        // product-form.js (chequea aria-disabled sobre SU propio botón
        // al recibir el submit), esto solo evita el .click() de más.
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        realButton.click();
      });
    }

    // Visibilidad: aparece únicamente cuando el botón real de compra
    // sale del viewport por scroll (IntersectionObserver sobre el
    // botón real, no sobre la barra). rootMargin descuenta la altura
    // de la propia barra para que la transición no se solape con el
    // botón real justo en el punto de cruce.
    var barHeight = root.getBoundingClientRect().height || 70;
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        var shouldShow = !entry.isIntersecting;
        root.classList.toggle('is-visible', shouldShow);
        root.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      },
      {
        root: null,
        rootMargin: '0px 0px -' + Math.round(barHeight) + 'px 0px',
        threshold: 0,
      }
    );
    observer.observe(realButton);
  }

  function boot() {
    document.querySelectorAll('[data-dm-sticky-atc]:not([data-dm-bound])').forEach(function (root) {
      root.setAttribute('data-dm-bound', 'true');
      initDmStickyAtc(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Reinicializa si product-info vuelve a montarse desde cero (caso
  // límite: combined listings que reemplazan <main> completo al
  // cambiar de variante-producto). No aplica al catálogo actual de
  // esta tienda (el color es una opción de variante del mismo
  // producto, no un producto enlazado distinto), pero se deja como
  // red de seguridad barata.
  document.addEventListener('product-info:loaded', boot);
})();
